export function serializeToUrl(value: unknown): string {
  const rv = JSON.stringify(value).replace(/"/g, '');
  return rv;
}
